import React from "react";
import LiveSessionTowerImg from "../../../assets/images/offereings_techbots/LiveSessionTower.png";
const LiveSessionBadge: React.FC = () => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        background: "rgba(255, 255, 255, 0.9)",
        color: "#d32f2f",
        padding: "5px 5px",
        borderRadius: "8px",
        fontWeight: 600,
        fontSize: "14px",
        position: "absolute",
        top: "10px",
        left: "10px",
        boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
      }}
    >
      <img
        src={LiveSessionTowerImg}
        style={{
          width: "30px",
          height: "20px",
          marginRight: "3px",
          objectFit: "contain",
          borderRadius: "0",
          display: "inline-block",
        }}
        alt="Live Session"
      />

      <span
        style={{
          fontFamily: "Mazzard",
          fontSize: "14px",
          color: "#2D2D2D",
          fontWeight: "500",
        }}
      >
        with live sessions
      </span>
    </div>
  );
};

export default LiveSessionBadge;
